import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { selectCurrentFilterName, selectFiltersQuery, selectFirstSelectedMarketId } from '../../../modules/filters';
import { FiltersBar } from './filtersBar.component';
import { FiltersActions } from '../../../modules/filters/filters.redux';
import { selectMarketsCategories } from '../../../modules/market';

const mapStateToProps = createStructuredSelector({
  selectedMarketId: selectFirstSelectedMarketId,
  currentFilterName: selectCurrentFilterName,
  categoriesData: selectMarketsCategories,
  filtersQuery: selectFiltersQuery,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      animateModalByFilterName: FiltersActions.animateModalByFilterName,
      submitFilters: FiltersActions.submitFilters,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(FiltersBar);
